export default __webpack_public_path__ + "static/media/deo_sword.cf1bdb0a.bmp";